import { iIconProps } from '../icon';

export default function ChevronDownIcon({ size, ...props }: iIconProps): JSX.Element {
    return (
        <svg width={size} height={size} viewBox='0 0 24 24' {...props}>
            <path
                d='M12 16.34c-.73 0-1.43-.29-1.94-.81L3.47 8.94c-.29-.29-.29-.77 0-1.06s.77-.29 1.06 0l6.59 6.59c.47.47 1.29.47 1.77 0l6.59-6.59c.29-.29.77-.29 1.06 0s.29.77 0 1.06l-6.59 6.59c-.52.52-1.21.81-1.94.81Z'
                fill='currentColor'
            />
        </svg>
    );
}
